import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionCancelled = () => {
  const { currentCommunity } = usePunditUserContext();

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("pricing_plans.plan_cancelled")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("pricing_plans.to_access", {
          community_name: currentCommunity?.name,
        })}
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
